module.exports = __webpack_public_path__ + "static/media/asaas.3ebc0b2e.svg";